import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';
import { logout } from '../../utils/util-func';

export const onResponse = (res: AxiosResponse) => {
  const { method, url } = res.config;
  return res;
};

let isAlertShown = false;

export const onResError = (error: AxiosError | Error) => {
  if (axios.isAxiosError(error)) {
    const { method, url } = error.config as InternalAxiosRequestConfig;
    if (error.response) {
      const { statusCode, message } = error.response.data;
      const expectedUrl = [
        '/v1/auth/sign-in',
        '/v1/sms/with-name',
        '/v1/auth/user-authorization?check=true',
      ];

      // 반복 실패시 한번만 처리를 위한 코드
      if (isAlertShown) return;
      isAlertShown = true;
      setTimeout(() => {
        isAlertShown = false;
      }, 1000);

      if (expectedUrl.includes(url)) return Promise.reject(error);

      switch (statusCode) {
        case 401:
          alert('로그인이 필요합니다.');
          logout();
          if (!localStorage.getItem('redirect')) {
            if (window.location.href.split('/').pop() !== 'signin')
              localStorage.setItem('redirect', window.location.href);
          }
          window.location.href = '/signin';
          return error.response;

        case 403:
          alert('접근 권한이 없습니다.');
          window.location.href = '/';
          return error.response;

        default:
          return Promise.reject(error);
      }
    }
  } else {
    console.log(`🚨 [API] | Error ${error.message}`);
  }

  return Promise.reject(error);
};
